import { render } from "./logs-list-page.vue?vue&type=template&id=bce2a578&scoped=true"
import script from "./logs-list-page.vue?vue&type=script&lang=js"
export * from "./logs-list-page.vue?vue&type=script&lang=js"

import "./logs-list-page.vue?vue&type=style&index=0&id=bce2a578&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/security/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce2a578"]])

export default __exports__